import React from "react";

import { keyGenerator } from "../../../libs/Util";
import { ReactComponent as ArrowIcon } from "../../../assets/svg/caret_down.svg";
import { ReactComponent as LikedIcon } from "../../../assets/svg/like.svg";
import { ReactComponent as ChatIcon } from "../../../assets/svg/chat.svg";
import {
  ISimpleTeachingMaterial,
  ILessonByTeachingMaterial,
  IIssueN,
} from "../../../state";
import { Dropdown } from "../../../atoms/Dropdown";
import TeachingMaterialHeader from "../../../molecules/TeachingMaterialHeader";

import styles from "./QuestionList.module.scss";

export type Props = {
  teaching_materials: ISimpleTeachingMaterial[];
  listLessons?: ILessonByTeachingMaterial[];
  teachingMaterialId: number;
  onChangeTeachingMaterial: (id: number) => void;
};
const QuestionList: React.FC<Props> = ({
  teaching_materials,
  listLessons,
  teachingMaterialId,
  onChangeTeachingMaterial,
}) => {
  const [
    teachingMaterial,
    setTeachingMaterial,
  ] = React.useState<ISimpleTeachingMaterial>();

  const options = React.useMemo(() => {
    return teaching_materials.map(material => ({
      value: material.id,
      label: `${material.name} ${material.title}`,
    }));
  }, [teaching_materials]);

  const defaultValue = React.useMemo(() => {
    return options.find(o => o.value === teachingMaterialId);
  }, [options, teachingMaterialId]);

  const SortIssueByID = (objs: IIssueN[]) => {
    return objs.sort((a, b) => (a.id > b.id ? 1 : b.id > a.id ? -1 : 0));
  };

  return (
    <div className={styles.wrapperListQuestion}>
      <Dropdown
        options={options}
        defaultValue={defaultValue}
        onChange={data => {
          onChangeTeachingMaterial(data);
          setTeachingMaterial(
            teaching_materials.filter(material => material.id === data)[0],
          );
        }}
      />
      <div className={styles.contents}>
        {teachingMaterial && (
          <TeachingMaterialHeader teachingMaterial={teachingMaterial} />
        )}

        {listLessons &&
          listLessons.map(lesson => (
            <div
              className={styles.wrapperListQuestion__questions}
              key={lesson.id}
            >
              <p>{`${lesson.name} ${lesson.title}`}</p>
              {SortIssueByID(lesson.issues).map(issue => (
                <div key={keyGenerator(issue)}>
                  <div
                    className={styles.titleQuestion}
                    data-bs-toggle="collapse"
                    data-bs-target={`#item${keyGenerator(issue)}`}
                    aria-expanded="false"
                    aria-controls={`#item${keyGenerator(issue)}`}
                  >
                    <ArrowIcon />
                    <span>{issue.title}</span>
                  </div>
                  <div
                    id={`item${keyGenerator(issue)}`}
                    className={`collapse ${styles.listQuestion}`}
                  >
                    {issue.answers.map(answer => (
                      <div
                        className={styles.section}
                        key={keyGenerator(answer)}
                      >
                        {answer.contents?.map(answerContent => (
                          <div
                            className={`${styles.itemContent}`}
                            key={answerContent.question_id}
                          >
                            <div className={styles.question}>
                              {answerContent.statement}
                            </div>
                            <div className={styles.answer}>
                              {answerContent.content}
                            </div>
                          </div>
                        ))}
                        <div className={styles.interactive}>
                          <LikedIcon /> <span>{answer.like_num}</span>
                          <ChatIcon /> <span>{answer.comment_num}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          ))}
      </div>
    </div>
  );
};

export default QuestionList;
